﻿<script setup>
    import { useDialogPluginComponent } from 'quasar'
    const { dialogRef, onDialogHide, onDialogOK, onDialogCancel } = useDialogPluginComponent()
    defineEmits([...useDialogPluginComponent.emits])

    const props = defineProps({
        data: Array
    });
</script>

<template>
    <q-dialog ref="dialogRef" @hide="onDialogHide" :persistent="true">
        <window title="Validation Error" icon="error" size="sm">
            <template #actions>
                <btnOk flat @click="onDialogOK" />
            </template>
            <div v-for="e in data">- {{e.Message}}</div>
        </window>
    </q-dialog>
</template>